($ => {
  const App = (() => {
    // Base UI Actions
    function bindUiActions() {
      $(".js-clear-values").on("click", e => {
        e.preventDefault();
        const inputsToClear = $(e.target)
          .data("clear-targets")
          .split(" ");

        inputsToClear.forEach(input => {
          $(`[name=${input}]`)
            .val("")
            .trigger("change");
        });
      });

      $(document).ready(() => {
        if ($(window).outerWidth() < 1280) {
          mobileLayout();
        }
      });

      const windowResize = debounce(() => {
        mobileLayout();
      }, 100);

      $(window).on("resize", windowResize);
    }

    function mobileLayout() {
      const $studentsFilters = $("#block-students-competition-filters"),
        $eventsListFilters = $(".events--calendar-list .view__filters"),
        $sidebar = $(".sidebar");

      if ($(window).outerWidth() < 1280) {
        if ($studentsFilters.length) {
          $studentsFilters.appendTo($eventsListFilters);
        }
      } else {
        if ($studentsFilters.length) {
          $studentsFilters.appendTo($sidebar);
        }
      }
    }

    function debounce(func, wait, immediate) {
      let timeout;
      return () => {
        const context = this,
          args = arguments;
        const later = () => {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    }

    return {
      init: () => {
        bindUiActions();
      }
    };
  })();

  App.init();
})(jQuery);
